import React from 'react';
import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const Section = styled.section`
  height: 100%;
  margin: 80px 32px;

  @media (width >= 768px) {
    margin: 80px 60px 180px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 320px;
  max-width: 400px;
  background: linear-gradient(160.38deg, #9F2DEB 27.29%, #6200A3 91.44%);
  border-radius: 13px;
  padding: 30px 40px;
  margin: 0 auto;

  @media (width >= 768px) {
    max-width: 1100px;
    min-height: 247px;
    background: linear-gradient(97.16deg, #9F2DEB 36.11%, #6200A3 107.05%);
    flex-direction: row;
    padding-top: 30px;
    padding-right: 20px;
    padding-left: 20px;
    justify-content: center;
  }
`;

const Thumbnail = styled(Image)`
  border-radius: 15px;
  margin-bottom: 18px;

  @media (width >= 768px) {
    width: 367px;
    height: 169px;
    margin-bottom: 0;
  }
`;

const Title = styled(Typography)`
  font-size: 22px;
  font-weight: 500;
  line-height: 28.8px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #FFF;
  white-space: pre-line;
  margin-bottom: 20px;

  @media (width >= 768px) {
    font-size: 36px;
    line-height: 40.32px;
    letter-spacing: -0.03em;
    text-align: left;
  }
`;

function NuCommunity() {
  return (
    <Section>
      <Container>

        <Box
          display="flex"
          width="100%"
          flexDirection={{
            xs: 'column',
            md: 'row-reverse',
          }}
          justifyContent={{
            xs: 'center',
            md: 'space-evenly',
          }}
        >
          <Thumbnail
            src="atencion/comunidad-logo.jpg"
            alt="Vista previa del video"
          />

          <Box
            display="flex"
            flexDirection="column"
            alignItems={{
              xs: 'center',
              md: 'flex-start',
            }}
            justifyContent="center"
          >
            <Title strong>
              Comparte y lee
              {' '}
              <Box tag="br" display={{ xs: 'block', lg: 'none' }} />
              opiniones
              {' '}
              <Box tag="br" display={{ xs: 'none', lg: 'block' }} />
              {' '}
              de más
              {' '}
              <Box tag="br" display={{ xs: 'block', lg: 'none' }} />
              {' '}
              clientes Nu
            </Title>

            <Link href="https://comunidad.nu.com.mx/" variant="action" color="white">
              Ir a Comunidad Nu
            </Link>
          </Box>
        </Box>

      </Container>
    </Section>
  );
}

export default NuCommunity;
